'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.promise.with-resolvers');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/esnext.promise.with-resolvers.js
// module id = 739
// module chunks = 13